// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vrs4","placeholdersHeader":"styles_placeholdersHeader__3gQ5Y","editorStyle":"styles_editorStyle__34FY0","placeholdersBox":"styles_placeholdersBox__3_pOa"};